export enum actionTypes {
    REQUEST_DOCUMENT_REQUEST_HISTORY = "request_document_request_history",
    RECEIVE_DOCUMENT_REQUEST_HISTORY = "received_document_request_history",
    COMPLETED_DOCUMENT_REQUEST_HISTORY = "completed_document_request_history",

    REQUEST_DOCUMENT_REQUEST_HISTORY_METRICS = "request_document_request_metrics",
    RECEIVE_DOCUMENT_REQUEST_HISTORY_METRICS = "received_document_request_metrics",
    COMPLETED_DOCUMENT_REQUEST_HISTORY_METRICS = "completed_document_request_metrics",
}
